module.exports = __webpack_public_path__ + "3da9d551de2227af6b15a2e7a3cfd1b8.png";